import styles from './style.module.scss';

type Props = {
  areaState?: string
  onClick: () => void
}

const SearchQuerySubmit = ({ areaState, onClick }: Props) => {
  return (
    <div className={styles.searchQuerySubmit}>
      <button type='button' onClick={() => onClick()}>
        <span>絞り込む</span>
        <span className={styles.searchQuerySubmitIcon}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="7.375" cy="7.375" r="4.375" stroke="white" />
            <path d="M13 13L11.125 11.125" stroke="white" />
          </svg>
        </span>
      </button>
    </div>
  )
}

export { SearchQuerySubmit }
